import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getAuditList = createAsyncThunk(
  "get-audit",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("audit/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createAudit = createAsyncThunk(
  "create-audit",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("audit", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteAudit = createAsyncThunk(
  "delete-audit",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`audit/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const auditSlice = createSlice({
  name: "audit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAuditList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAuditList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.auditList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getAuditList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default auditSlice.reducer;
